/* ==========================================================================
   NOOK theme - shared behavior. No framework, no build step - copy-paste
   safe inside a Shopify theme's assets folder.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initQtySteppers();
  initProductForm();
  initGalleryThumbs();
  initCartQtyForms();
  initAutoDescription();
});

/* ---------- Auto-styled product description ----------
   Reads the plain HTML a merchant typed into the product's normal
   Description field and re-shapes recognizable patterns into the
   theme's visual language - no blocks, no theme editor setup per
   product. Conventions:
     <h2>/<h3> immediately followed by <ul>  -> highlight chip grid
     <h2>/<h3> immediately followed by <p> (optionally containing
       or followed by an <img>)              -> alternating story block
     <ol>                                    -> numbered "how to use" steps
     <blockquote>                            -> big pull-quote
     anything else                           -> plain spaced paragraph
*/
function initAutoDescription() {
  var DEFAULT_ICONS = ['✨', '🌊', '🎨', '📦', '🌿', '⚡', '🧵', '🔥'];

  document.querySelectorAll('[data-auto-desc]').forEach(function (root) {
    var children = Array.prototype.slice.call(root.children);
    var frag = document.createDocumentFragment();
    var storyIndex = 0;

    function splitTitleText(raw) {
      var m = raw.match(/^(.*?)[:\u2013\u2014-]\s+(.*)$/);
      if (m && m[1].length < 40) return { title: m[1].trim(), text: m[2].trim() };
      return { title: raw.trim(), text: '' };
    }

    function extractIcon(raw, fallbackIdx) {
      var m = raw.match(/^(\p{Extended_Pictographic}\uFE0F?)\s*/u);
      if (m) return { icon: m[1], rest: raw.slice(m[0].length) };
      return { icon: DEFAULT_ICONS[fallbackIdx % DEFAULT_ICONS.length], rest: raw };
    }

    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      var tag = el.tagName;

      if (tag === 'H2' || tag === 'H3' || tag === 'H4') {
        var headingText = el.textContent.trim();
        var next = children[i + 1];

        if (next && next.tagName === 'UL') {
          var heading = document.createElement('h3');
          heading.className = 'auto-heading';
          heading.textContent = headingText;
          frag.appendChild(heading);

          var grid = document.createElement('div');
          grid.className = 'highlight-grid';
          Array.prototype.forEach.call(next.children, function (li, idx) {
            var raw = li.textContent.trim();
            var parsedIcon = extractIcon(raw, idx);
            var parts = splitTitleText(parsedIcon.rest);
            var item = document.createElement('div');
            item.className = 'highlight-item';
            var iconSpan = document.createElement('span');
            iconSpan.className = 'highlight-icon i' + (idx % 3);
            iconSpan.textContent = parsedIcon.icon;
            var textWrap = document.createElement('div');
            var titleEl = document.createElement('div');
            titleEl.className = 'highlight-title';
            titleEl.textContent = parts.title;
            textWrap.appendChild(titleEl);
            if (parts.text) {
              var textEl = document.createElement('div');
              textEl.className = 'highlight-text';
              textEl.textContent = parts.text;
              textWrap.appendChild(textEl);
            }
            item.appendChild(iconSpan);
            item.appendChild(textWrap);
            grid.appendChild(item);
          });
          frag.appendChild(grid);
          i++;
          continue;
        }

        if (next && next.tagName === 'P') {
          var img = next.querySelector('img');
          var afterPara = children[i + 2];
          var consumedImgSibling = false;
          if (!img && afterPara && afterPara.tagName === 'IMG') {
            img = afterPara;
            consumedImgSibling = true;
          }
          var block = document.createElement('div');
          block.className = 'story-block' + (storyIndex % 2 === 1 ? ' reverse' : '');
          var media = document.createElement('div');
          media.className = 'story-media';
          if (img) {
            var imgClone = img.cloneNode(true);
            media.appendChild(imgClone);
          }
          var textDiv = document.createElement('div');
          textDiv.className = 'story-text';
          var h3 = document.createElement('h3');
          h3.textContent = headingText;
          var p = document.createElement('p');
          p.innerHTML = next.innerHTML.replace(/<img[^>]*>/gi, '');
          textDiv.appendChild(h3);
          textDiv.appendChild(p);
          block.appendChild(media);
          block.appendChild(textDiv);
          frag.appendChild(block);
          storyIndex++;
          i++;
          if (consumedImgSibling) i++;
          continue;
        }

        var plainHeading = el.cloneNode(true);
        plainHeading.classList.add('auto-heading');
        frag.appendChild(plainHeading);
        continue;
      }

      if (tag === 'OL') {
        var wrap = document.createElement('div');
        wrap.className = 'how-to-wrap';
        var stepsHeading = document.createElement('h3');
        stepsHeading.textContent = 'How to use';
        wrap.appendChild(stepsHeading);
        Array.prototype.forEach.call(el.children, function (li, idx) {
          var step = document.createElement('div');
          step.className = 'how-to-step';
          var num = document.createElement('span');
          num.className = 'step-num';
          num.textContent = idx + 1;
          var body = document.createElement('div');
          body.className = 'step-body';
          body.innerHTML = '<p>' + li.innerHTML + '</p>';
          step.appendChild(num);
          step.appendChild(body);
          wrap.appendChild(step);
        });
        frag.appendChild(wrap);
        continue;
      }

      if (tag === 'BLOCKQUOTE') {
        var q = document.createElement('div');
        q.className = 'testimonial';
        var mark = document.createElement('div');
        mark.className = 'quote-mark';
        mark.innerHTML = '&ldquo;';
        var bq = document.createElement('blockquote');
        bq.innerHTML = el.innerHTML;
        q.appendChild(mark);
        q.appendChild(bq);
        frag.appendChild(q);
        continue;
      }

      var clone = el.cloneNode(true);
      clone.classList.add('auto-prose');
      frag.appendChild(clone);
    }

    root.innerHTML = '';
    root.appendChild(frag);
  });
}

/* ---------- Mobile menu ---------- */
function initMobileMenu() {
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', function () {
    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}

/* ---------- Quantity steppers (product page + cart page) ---------- */
function initQtySteppers() {
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-qty-input]');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);

    function setValue(v) {
      v = Math.max(min, v);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () {
      setValue((parseInt(input.value, 10) || min) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      setValue((parseInt(input.value, 10) || min) + 1);
    });
  });
}

/* ---------- Cart page: quantity change auto-submits the update form ---------- */
function initCartQtyForms() {
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
}

/* ---------- Product gallery thumbnails ---------- */
function initGalleryThumbs() {
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main-img]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (main && thumb.dataset.fullSrc) {
          main.src = thumb.dataset.fullSrc;
        }
      });
    });

    var track = gallery.querySelector('[data-thumb-track]');
    var prev = gallery.querySelector('[data-thumb-prev]');
    var next = gallery.querySelector('[data-thumb-next]');
    if (track && prev && next) {
      var step = function () {
        var first = track.querySelector('[data-gallery-thumb]');
        var gap = 12;
        return first ? first.offsetWidth * 2 + gap * 2 : 176;
      };
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  });
}

/* ---------- Product form: variant selection + ajax add to cart ---------- */
function initProductForm() {
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variantIdInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var optionInputs = root.querySelectorAll('[data-option-index]');
    var selected = {};

    // seed from whatever is marked active by default in the markup
    optionInputs.forEach(function (el) {
      if (el.classList.contains('active')) {
        selected[el.dataset.optionIndex] = el.dataset.value;
      }
    });

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: product.currency || 'INR' });
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) {
          return selected[i] === undefined || selected[i] === val;
        });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.availableLabel : addBtn.dataset.soldOutLabel;
      }
      if (variant.featured_media) {
        var mainImg = root.closest('.product-main') && root.closest('.product-main').querySelector('[data-gallery-main-img]');
        if (mainImg && variant.featured_media.preview_image) {
          mainImg.src = variant.featured_media.preview_image.src;
        }
      }
    }

    optionInputs.forEach(function (el) {
      el.addEventListener('click', function () {
        var group = root.querySelectorAll('[data-option-index="' + el.dataset.optionIndex + '"]');
        group.forEach(function (g) { g.classList.remove('active'); });
        el.classList.add('active');
        selected[el.dataset.optionIndex] = el.dataset.value;
        var labelTarget = root.querySelector('[data-option-value-label="' + el.dataset.optionIndex + '"]');
        if (labelTarget) labelTarget.textContent = el.dataset.value;
        updateUI();
      });
    });

    var form = root.querySelector('form[data-product-add-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.dataset.originalText = addBtn.textContent; addBtn.textContent = 'Adding...'; }
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function () { return fetch('/cart.js'); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            if (addBtn) addBtn.textContent = 'Added';
            setTimeout(function () {
              if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.originalText; }
            }, 1500);
          })
          .catch(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.originalText || 'Add to cart'; }
          });
      });
    }

    updateUI();
  });
}
